import React, { useEffect, useState } from 'react'

export default function LandingPage({ onSignIn }) {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => setLoaded(true), 100)
  }, [])

  return (
    <div style={{
      minHeight: '100dvh',
      background: 'linear-gradient(160deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
      padding: '24px',
      position: 'relative',
      overflow: 'hidden',
    }}>

      {/* Background orbs */}
      <div style={{
        position: 'absolute', top: '-80px', right: '-80px',
        width: '320px', height: '320px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(233,69,96,0.15) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', bottom: '-60px', left: '-60px',
        width: '260px', height: '260px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(88,86,214,0.15) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', top: '40%', left: '-40px',
        width: '180px', height: '180px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(52,199,89,0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      {/* Content */}
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        maxWidth: '400px', width: '100%', textAlign: 'center',
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(16px)',
        transition: 'opacity 0.6s ease, transform 0.6s ease',
      }}>

        {/* Logo mark */}
        <div style={{
          width: '80px', height: '80px', borderRadius: '24px',
          background: 'linear-gradient(135deg, #e94560, #c13652)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: '28px',
          boxShadow: '0 8px 32px rgba(233,69,96,0.35)',
        }}>
          <span style={{ fontSize: '36px' }}>🏠</span>
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: '32px', fontWeight: '800', color: 'white',
          letterSpacing: '-0.6px', marginBottom: '10px', lineHeight: 1.2,
        }}>
          Bailey Family Portal
        </h1>

        {/* Subtitle */}
        <p style={{
          fontSize: '16px', color: 'rgba(255,255,255,0.55)',
          marginBottom: '48px', lineHeight: 1.5, maxWidth: '280px',
        }}>
          Your private family hub for budgets, photos, fitness, and more.
        </p>

        {/* Feature pills */}
        <div style={{
          display: 'flex', flexWrap: 'wrap', gap: '8px',
          justifyContent: 'center', marginBottom: '48px',
        }}>
          {['💰 Budget', '📷 Photos', '💬 Social', '📅 Calendar', '💪 Fitness'].map(f => (
            <span key={f} style={{
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.12)',
              borderRadius: '20px', padding: '6px 14px',
              fontSize: '13px', color: 'rgba(255,255,255,0.7)',
              fontWeight: '500',
            }}>{f}</span>
          ))}
        </div>

        {/* Sign in button */}
        <button
          onClick={onSignIn}
          style={{
            width: '100%', padding: '16px',
            background: 'linear-gradient(135deg, #e94560, #c13652)',
            color: 'white', border: 'none', borderRadius: '16px',
            fontSize: '17px', fontWeight: '700', cursor: 'pointer',
            boxShadow: '0 8px 24px rgba(233,69,96,0.4)',
            letterSpacing: '-0.2px',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          Sign In
        </button>

        <p style={{
          fontSize: '12px', color: 'rgba(255,255,255,0.3)',
          marginTop: '20px',
        }}>
          Private access only · Bailey family members
        </p>
      </div>

      {/* Bottom wordmark */}
      <p style={{
        position: 'absolute', bottom: '24px',
        fontSize: '12px', color: 'rgba(255,255,255,0.2)',
        letterSpacing: '0.5px',
      }}>
        baileyit.org
      </p>
    </div>
  )
}
